"use client";

import { cn } from "utils";
import { useSnapshot } from "valtio";
import log from "logbeacon";
import { AvatarWithFallback } from "../AvatarWithFallback";
import { useIsPc, useMemberUser, useShellRouter } from "@hooks";
import { HomeStore } from "@store";
import { I18nUtil } from "@utils/i18n";
import { ROUTER_PATH } from "@/src/config";
import Translations from "@translate/components/Menu/ProfileButton";
import { getDisplayBadgeName } from "../Member/shared/planDisplayUtils";
import { MemberKeys } from "@/src/screens/Member";

const I18n = I18nUtil.createScoped(Translations);

export type ProfileButtonProps = {
  clickEnable?: boolean;
  avatar?: string;
  userName?: string;
  logout?: () => Promise<void>;
  avatarClassName?: string;
  buttonClassName?: string;
  containerClassName?: string;
  menuClassName?: string;
  menuBtnClassName?: string;
};

export const ProfileButton = (props: ProfileButtonProps) => {
  const { avatar, userName, clickEnable = true } = props;
  const { data } = useMemberUser();
  const productName = getDisplayBadgeName(data?.level);
  const isFree = data?.isFree;
  const [isPc] = useIsPc();
  const { isOpen } = useSnapshot(HomeStore);
  const router = useShellRouter();

  const isShowUpgradeButton = isFree && isPc;
  const avatarSize = isPc ? 36 : 48;

  return (
    <div className={cn("relative flex justify-between w-full items-center")}>
      <button
        aria-label="Profile Button"
        data-openreplay-label="Profile Button Button"
        id="btn-profile-button"
        className={cn("flex flex-row items-center gap-2")}
        onClick={() => {
          if (!clickEnable) {
            return;
          }
          router.push(ROUTER_PATH.SETTING);
        }}
      >
        <AvatarWithFallback
          src={avatar}
          alt="User Avatar"
          width={avatarSize}
          height={avatarSize}
        />
        {isOpen && (
          <div className="flex flex-col items-start gap-0.5">
            <div className="text-content_primary body_medium_m max-w-[140px] truncate">
              {userName}
            </div>
            {/* V3.0.3: badge 动态展示 — 付费用户显示等级(brand色)，免费用户显示 Free */}
            <span
              className={cn(
                "body_medium_s",
                isFree
                  ? "text-content_secondary"
                  : "text-content_brand_primary",
              )}
            >
              {isFree ? I18n.t("Free") : productName || I18n.t("Complete")}
            </span>
          </div>
        )}
      </button>
      {isShowUpgradeButton && (
        <button
          className="bg-background_accent4_overlay100 rounded-[6px] px-2 py-[6px] text-content_inverse_primary button_s"
          onClick={() => {
            router.push(`${ROUTER_PATH.MEMBER}/?tab=${MemberKeys.PRICING}`);
            log.info(
              "[member][entry]: menu profile button click to goto buy member",
            );
          }}
        >
          {I18n.t("Upgrade")}
        </button>
      )}
    </div>
  );
};
